var _jsxFileName = "/home/runner/work/infra-frontends/infra-frontends/libs/ui-design-system/src/styles/ThemeProvider.tsx",
  _this = this;
import { ThemeProvider as Provider } from '@emotion/react';
import { createTheme, StyledEngineProvider, ThemeProvider as MuiThemeProvider } from '@mui/material';
import { deepmerge } from '@mui/utils';
import { baseTheme } from "./base";
import { jsx as _jsx } from "react/jsx-runtime";
export var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
    theme = _ref.theme,
    _ref$injectFirst = _ref.injectFirst,
    injectFirst = _ref$injectFirst === void 0 ? true : _ref$injectFirst;
  var mergedTheme = deepmerge(baseTheme, theme !== null && theme !== void 0 ? theme : {});
  var muiTheme = createTheme(mergedTheme);
  return _jsx(StyledEngineProvider, {
    injectFirst: injectFirst,
    children: _jsx(MuiThemeProvider, {
      theme: muiTheme,
      children: _jsx(Provider, {
        theme: muiTheme,
        children: children
      })
    })
  });
};
//# sourceMappingURL=ThemeProvider.js.map